export const WALL_TYPE = {
  OTHER: "Other",
  OTHER_WALLS: "Other walls",
};

export const ROOF_TYPE = {
  OTHER: "Other",
  OTHER_ROOF: "Other roof",
};

export const PROPERTY_LOOKUP = [
  "PropertyType",
  "NumberOfBedrooms",
  "NumberOfBathrooms",
  "BuildYear",
  "WallConstruction",
  "RoofConstruction",
];

export const PROPERTY_STATUS_ITEMS = [
  {
    text: "Owned Outright",
    value: "OwnedOutright",
  },
  {
    text: "Owned Mortgaged",
    value: "OwnedMortgaged",
  },
  {
    text: "Rented from Private Landlord",
    value: "RentedFromPrivateLandlord",
  },
  {
    text: "Rented from Local Authority / Housing Association",
    value: "RentedFromLocalAuthorityOrHousingAssociation",
  },
];

export const MORTGAGE_CATEGORY_ITEMS = [
  {
    text: "First time buyer",
    value: "FirstTimeBuyer",
  },
  {
    text: "Home mover",
    value: "MovingHouse",
  },
  {
    text: "No mortgage transaction",
    value: "ExistingMortgage",
  },
  {
    text: "Product transfer",
    value: "ProductTransfer",
  },
  {
    text: "Remortgage",
    value: "RemortgagingCurrentProperty",
  },
];

export const ANSWER_NUMBER_OF_ADULTS_COUNTER_OPTIONS = {
  Count: 1,
  CountValues: {
    1: {
      Value: "One",
      DisplayValue: "1",
    },
    2: {
      Value: "Two",
      DisplayValue: "2",
    },
    3: {
      Value: "Three",
      DisplayValue: "3",
    },
    4: {
      Value: "Four",
      DisplayValue: "4",
    },
    5: {
      Value: "Five",
      DisplayValue: "5",
    },
    6: {
      Value: "Six",
      DisplayValue: "6",
    },
    7: {
      Value: "Seven",
      DisplayValue: "7",
    },
    8: {
      Value: "Eight",
      DisplayValue: "8",
    },
    9: {
      Value: "NinePlus",
      DisplayValue: "9+",
    },
  },
  CountMaxValue: 9,
  CountMinValue: 1,
};

export const ANSWER_NUMBER_OF_CHILDREN_COUNTER_OPTIONS = {
  Count: 0,
  CountValues: {
    0: {
      Value: "Zero",
      DisplayValue: "0",
    },
    1: {
      Value: "One",
      DisplayValue: "1",
    },
    2: {
      Value: "Two",
      DisplayValue: "2",
    },
    3: {
      Value: "Three",
      DisplayValue: "3",
    },
    4: {
      Value: "Four",
      DisplayValue: "4",
    },
    5: {
      Value: "Five",
      DisplayValue: "5",
    },
    6: {
      Value: "Six",
      DisplayValue: "6",
    },
    7: {
      Value: "Seven",
      DisplayValue: "7",
    },
    8: {
      Value: "Eight",
      DisplayValue: "8",
    },
    9: {
      Value: "NinePlus",
      DisplayValue: "9+",
    },
  },
  CountMaxValue: 9,
  CountMinValue: 0,
};

export const UNAPPROVED_MORTGAGE_APPLICATION_ITEMS = [
  {
    text: "Yes",
    value: "true",
  },
  {
    text: "No",
    value: "false",
  },
];
